<template>
  <fts-design-modal
    class="fts-module-history-modal"
    ref="ftsDesignModal"
    @closed="reset"
  >
    <!-- title -->
    <template #title>
      <div class="design-modal-header-std__title">
        <font-awesome-icon :icon="['fas', 'clock-rotate-left']" class="design-modal-header-icon" />
        <div class="design-modal-header-name">History</div>
      </div>
    </template>
    <!-- description -->
    <template #description>
      <span class="design-modal-header-tag">History</span>
      <span class="design-modal-header-description">
        Configuration changes
      </span>
    </template>
    <!-- body -->
    <template #body>
      <div class="design-modal-spinner" v-if="loading">
        <fts-spinner show />
      </div>
      <div v-else>
        <div
          v-for="history in list"
          :key="history.id"
          class="history-item"
        >
          <div class="history-item-details">
            <fts-profile
              :profile-photo-size="25"
              :user-name="history.audit && history.audit.updatedBy"
              class="fts-items-start"
            >
              <template #profileName="{userProfileName}">
                <div>
                  <span class="profile-name fts-font-medium">{{userProfileName}}</span>
                  <span v-if="history.description" class="fts-whitespace-pre-wrap">added {{history.description}}</span>
                  <span class="fts-whitespace-pre-wrap">{{history.changes}}</span>
                </div>
                <div class="fts-flex">
                  <fts-tippy :content="moment(history.audit.createdDate).format('llll')" class="history-item-date">
                    {{relativeDate(history.audit.createdDate)}}
                  </fts-tippy>
                </div>
              </template>
            </fts-profile>
          </div>

          <div class="history-item-action-wrapper">
            <fts-btn sm color="primary" outline text-transform-init @click="revertChanges(history)">
              Revert
            </fts-btn>
          </div>
        </div>
      </div>
    </template>
  </fts-design-modal>
</template>

<script>
import moment from 'moment';

import { store as canvasDesignStore } from '../store/canvasDesignStore';
import canvasDesign from '../commons/canvasDesign';
import commons from '../commons/commons';

import FTSBtn from '../elements/FTSBtn';
import FTSDesignModal from './FTSDesignModal';
import FTSProfile from '../elements/FTSProfile';
import FTSSpinner from '../elements/FTSSpinner';
import FTSTippy from '../elements/FTSTippy';

export default {
  components: {
    'fts-btn': FTSBtn,
    'fts-design-modal': FTSDesignModal,
    'fts-profile': FTSProfile,
    'fts-spinner': FTSSpinner,
    'fts-tippy': FTSTippy
  },
  data: () => ({
    list: [],
    resolve: null,
    loading: true
  }),
  methods: {
    moment,
    async show() {
      this.loading = true;
      return new Promise(async (resolve) => {
        this.resolve = resolve;
        this.$refs.ftsDesignModal.show();
        let response = await canvasDesignStore.dispatch('loadModuleHistory', {
          moduleId: canvasDesignStore.state.vectorId
        });
        this.list = response.data.history;
        this.loading = false;
      });
    },
    async revertChanges(history) {
      const res = await this.$confirmation.show({
        text: 'Are you sure you want to revert this revision?'
      });

      if (res === true) {
        let response = await canvasDesignStore.dispatch('revertChange', {
          moduleId: canvasDesignStore.state.vectorId,
          version: history.id
        });

        canvasDesign.initCanvas(response.data.vector.extension);
        this.resolve && this.resolve(response.data.vector.extension);
        this.close();
      }
    },
    close() {
      this.$refs.ftsDesignModal.close();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    relativeDate(date) {
      return commons.momentRelativeTime(date);
    }
  }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-module-history-modal {
  .history-item {
    position: relative;
    margin-bottom: 0.5rem;
    padding: 0.5rem;
    border-radius: $comfort-border-radius;
    &:hover {
      background-color: rgba(var(--fts-gray-100-rgb), 0.75);
      .history-item-action-wrapper {
        display: block;
      }
    }
  }
  .history-item-details {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .history-item-date {
    margin-top: 0.25rem;
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--fts-default);
  }
  .history-item-action-wrapper {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
    display: none;
    background-color: var(--fts-card-background);
  }
}
</style>